import { useQueryParameters } from '@/hooks/useQueryParameters';
import clsx from 'clsx';
import React from 'react';
import shallow from 'zustand/shallow';
import useRequestFormStore from '../../RequestFormStore';
import AttachmentsSection from './AttachmentsSection';
import { DicomSection } from './DicomSection';
import RequestSection from './RequestSection';

const FilesSection = () => {
  const [patient] = useRequestFormStore((store) => [store.patient], shallow);
  const parameters = useQueryParameters();

  return (
    <RequestSection
      bodyClassName="grid grid-cols-1 md:grid-cols-2 gap-12"
      title="3. Upload radiology studies, imaging and reports to support analysis"
    >
      <div>
        <h3 className="text-lg font-semibold text-gray-800 ">Upload radiology studies</h3>
        <p className="mb-3 text-gray-700">This includes DICOM files or CDs</p>
        <div className={clsx('w-full', !parameters.has('requestId') && 'bg-gray-100 rounded-lg')}>
          <DicomSection patientId={patient?.id} />
        </div>
      </div>
      <div>
        <h3 className="text-lg font-semibold text-gray-800 ">
					Upload reports and images (optional)
        </h3>
        <p className="mb-3 text-gray-700">
					This includes PDF, JPEG, TIFF, or other image files for additional analysis
        </p>
        <div className={clsx('w-full', !parameters.has('requestId') && 'bg-gray-100 rounded-lg')}>
          <AttachmentsSection />
        </div>
      </div>
    </RequestSection>
  );
};

export { FilesSection as default };
